import { useMemo } from 'react';
import { Theme, css } from '@emotion/react';
import { Box, Stack } from '@mui/system';
import { useTranslation } from '@scorenco/core';
import { EventPhaseCard } from '../../containers';
import { T_KEYS } from '../../translations/keys';
const getGameTypes = step => {
  if (step === 1) {
    return [1];
  }
  if (step === 2) {
    return [2];
  }
  if (step === 3) {
    return [4];
  }
  if (step === 4) {
    return [9];
  }
  return null;
};
export const EliminationCupMode = ({
  games
}) => {
  const {
    t
  } = useTranslation();
  const stepsArray = useMemo(() => {
    return Array(5).fill().map((_, i) => ({
      stepNumber: i + 1,
      games: getGameTypes(i + 1)?.map(gameType => games?.filter(game => game?.game?.game_type === gameType))
    })).filter(step => step?.games?.[0]?.length > 0).reverse();
  }, [games]);
  const firstStepLength = stepsArray[0]?.stepNumber;
  return <Stack direction="row" spacing={2} sx={{
    width: '100%'
  }} data-sentry-element="Stack" data-sentry-component="EliminationCupMode" data-sentry-source-file="EliminationCupMode.tsx">
      {stepsArray?.map((step, i) => {
      const totalGameLength = step.games?.map(games => games?.length)?.reduce((a, b) => a + b, 0);
      if (totalGameLength === 0) {
        return null;
      }
      let height;
      let step_style;
      if (totalGameLength === 1) {
        height = css`
            height: auto;
          `;
      } else if (firstStepLength === 2) {
        height = css`
            height: 30rem;
          `;
      } else if (step?.games[0]?.[0]?.game?.name === 'Demi-finale 1' && firstStepLength === 3) {
        height = css`
            height: 48rem;
          `;
      } else if (totalGameLength === 2) {
        height = css`
            height: 67rem;
          `;
      } else if (firstStepLength === 3) {
        height = css`
            height: 65rem;
          `;
      } else if (totalGameLength === 4) {
        height = css`
            height: 95rem;
          `;
      } else if (totalGameLength === 8) {
        height = css`
            height: 110rem;
          `;
      }
      return <Box key={i} sx={{
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
        ml: '0 !important',
        position: 'relative',
        p: '6rem 4rem 4rem 0'
      }}>
            <Box css={height} sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-between'
        }}>
              {step.games?.map((games, i) => {
            return games?.map((game, index) => {
              let step_name;
              let step_before_style;
              if (game?.game?.name === 'Finale') {
                step_name = t(T_KEYS.TOURNAMENTS_FINALES_LABEL);
              } else if (game?.game?.name === 'Demi-finale 1' || game?.game?.name === 'Demi-finale 2') {
                step_name = t(T_KEYS.TOURNAMENTS_SEMI_FINALS_LABEL);
                step_style = css`
                      &::before {
                        border: none;
                        margin: 0;
                      }

                      &:nth-child(odd):after {
                        height: 210px;
                      }
                    `;
              } else if (game?.game?.name === 'Quart 1' || game?.game?.name === 'Quart 2' || game?.game?.name === 'Quart 3' || game?.game?.name === 'Quart 4') {
                step_name = t(T_KEYS.TOURNAMENTS_QUARTER_FINALS_LABEL);
              } else if (game?.game?.name === 'Huitième 1' || game?.game?.name === 'Huitième 2' || game?.game?.name === 'Huitième 3' || game?.game?.name === 'Huitième 4' || game?.game?.name === 'Huitième 5' || game?.game?.name === 'Huitième 6' || game?.game?.name === 'Huitième 7' || game?.game?.name === 'Huitième 8') {
                step_name = t(T_KEYS.TOURNAMENTS_ROUND_OF_SIXTEEN_LABEL);
              }
              if (step_name === t(T_KEYS.TOURNAMENTS_FINALES_LABEL) || totalGameLength === 1) {
                step_style = css`
                      &:nth-child(odd):after {
                        border: none;
                        margin: 0;
                      }
                    `;
              } else if (step_name === t(T_KEYS.TOURNAMENTS_SEMI_FINALS_LABEL) || totalGameLength === 2) {
                if (firstStepLength === 2) {
                  step_before_style = css`
                        &::before {
                          border: none;
                          margin: 0;
                        }
                      `;
                  step_style = css`
                        &:nth-child(odd):after {
                          height: 23vh;
                        }
                      `;
                }
                if (firstStepLength === 3) {
                  step_style = css`
                        &:nth-child(odd):after {
                          height: 50vh;
                        }
                      `;
                }
                if (firstStepLength === 4) {
                  step_style = css`
                        &:nth-child(odd):after {
                          height: 72vh;
                        }
                      `;
                }
              } else if (step_name === t(T_KEYS.TOURNAMENTS_QUARTER_FINALS_LABEL) || totalGameLength === 4) {
                step_style = css`
                      &:nth-child(odd):after {
                        height: 36vh;
                      }
                    `;
                if (firstStepLength === 3) {
                  step_before_style = css`
                        &::before {
                          border: none;
                          margin: 0;
                        }
                      `;
                  step_style = css`
                        &:nth-child(odd):after {
                          height: 20vh;
                        }
                      `;
                }
              } else if (step_name === t(T_KEYS.TOURNAMENTS_ROUND_OF_SIXTEEN_LABEL) && firstStepLength === 4) {
                step_before_style = css`
                      &::before {
                        border: none;
                        margin: 0;
                      }
                    `;
              }
              return <Box css={[step_style, step_before_style]} key={i} sx={{
                boxSizing: 'content-box',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: '1.25rem',
                borderRadius: '8px',
                color: (theme: Theme) => theme.vars.palette.text.primary,
                backgroundColor: (theme: Theme) => theme.vars.palette.background.paper2,
                '&::before': {
                  content: '""',
                  border: '2px solid',
                  borderColor: (theme: Theme) => theme.vars.palette.primary.main,
                  position: 'absolute',
                  left: '-18px',
                  width: '50px',
                  zIndex: 1,
                  marginTop: '5.5rem'
                },
                '&:nth-child(odd):after': {
                  content: '""',
                  position: 'absolute',
                  right: '18px',
                  width: '60px',
                  zIndex: 1,
                  marginTop: '5.5rem',
                  height: '15vh',
                  borderRight: '4px solid',
                  borderRightColor: (theme: Theme) => theme.vars.palette.primary.main,
                  borderTop: '4px solid',
                  borderTopColor: (theme: Theme) => theme.vars.palette.primary.main,
                  borderRadius: '0 4px 0 0'
                },
                '&:nth-child(even):after': {
                  borderTop: 'none',
                  content: '""',
                  position: 'absolute',
                  right: '18px',
                  width: '60px',
                  zIndex: 1,
                  marginTop: '0 !important',
                  height: '75px !important',
                  borderRight: '4px solid',
                  borderRightColor: (theme: Theme) => theme.vars.palette.primary.main,
                  borderBottom: '4px solid',
                  borderBottomColor: (theme: Theme) => theme.vars.palette.primary.main,
                  borderRadius: '0 0 4px 0'
                }
              }}>
                      {index === 0 && <Box sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  fontSize: '1.5rem',
                  textTransform: 'uppercase',
                  position: 'absolute',
                  top: 0,
                  margin: 0,
                  width: '100%',
                  height: '2.5rem'
                }}>
                          <h3 css={theme => css`
                              font-size: 1.5rem;
                              text-transform: uppercase;
                              text-align: center;
                              border-bottom: 3px solid
                                ${theme.vars.palette.primary.main};
                              padding-bottom: 0.5rem;
                              position: absolute;
                              top: 0;
                              margin: 0;
                              width: 86%;
                            `}>
                            {step_name}
                          </h3>
                        </Box>}
                      <EventPhaseCard key={game.game?.id} game={{
                  id: game.game?.id,
                  place: game.game?.place,
                  status: game.game?.status,
                  date: game.game?.date,
                  time: game.game?.date,
                  teams: [{
                    score: game.game?.home_score,
                    data: {
                      shootout: game.game?.home_shootout
                    },
                    name_in_competition: game.game?.home_engagement?.team?.name || game.game?.home_engagement?.name,
                    ...game.game?.home_engagement?.team
                  }, {
                    score: game.game?.away_score,
                    data: {
                      shootout: game.game?.away_shootout
                    },
                    name_in_competition: game.game?.away_engagement?.team?.name || game.game?.away_engagement?.name,
                    ...game.game?.away_engagement?.team
                  }]
                }} />
                    </Box>;
            });
          })}
            </Box>
          </Box>;
    })}
    </Stack>;
};